import Radio from '@veeva/corgix/radio';
import PropTypes from 'prop-types';
import addSavedFilter from '../../services/data/addSavedFilter';
import deleteSavedFilter from '../../services/data/deleteSavedFilter';
import doesFilterNameExist from '../../services/doesFilterNameExist';
import getVaultBasicsFilterOption from '../../services/getVaultBasicsFilterOption';
import { showInvalidFilterNameNotification } from '../../../common/services/notifications';
import VaultBasicsFilterOptions from '../../services/VaultBasicsFilterOptions';
import pageIdentifiersPageType from '../PageIdentifiersPageType';
import CustomerStatFilterRadioCopyDeleteButtons from './CustomerStatFilterRadioCopyDeleteButtons';
import {
    customerStatFilterRadioCSS,
    selectedRadioCSS,
} from './styles/CustomerStatFilterSavedFiltersSelection.styles';
import pageGroupType from '../PageGroupType';

export default function CustomCustomerStatFilter({
    userPreferenceFilters,
    setUserPreferenceFilters,
    setPendingFilterList,
    setPendingFilterQuery,
    setPendingFilterId,
    selectedCustomerFilterList,
    handleSetSelectedCustomerList,
    pendingFilterId,
    pendingFilterQuery,
    pendingFilterList,
    mobile,
    familyId,
    pageGroup,
    setErrorMsg,
}) {
    const handleHoverDeleteClick = (filterName) => {
        const matchFilter = userPreferenceFilters.filter((f) => f.filterName === filterName);
        if (matchFilter.length !== 0) {
            if (pageGroup === pageGroupType.ALL_CUSTOMERS) {
                deleteSavedFilter(
                    {
                        pageGroup,
                        pageType: pageIdentifiersPageType.CUSTOMERS,
                    },
                    matchFilter[0].id,
                );
            } else {
                deleteSavedFilter(
                    {
                        pageGroup,
                        pageType: pageIdentifiersPageType.TOTALS,
                        familyId,
                    },
                    matchFilter[0].id,
                );
            }

            setPendingFilterList([]);
            setPendingFilterQuery('');
            setPendingFilterId('');
            handleSetSelectedCustomerList('');
            setErrorMsg('');
            setUserPreferenceFilters(
                userPreferenceFilters.filter((f) => f.filterName !== filterName),
            );
        }
    };

    const handleCopyClick = async () => {
        if (pendingFilterList.length !== 0 && pendingFilterQuery.length !== 0) {
            if (doesFilterNameExist(userPreferenceFilters, `${selectedCustomerFilterList} 2`)) {
                showInvalidFilterNameNotification(`${selectedCustomerFilterList} 2`);
                return;
            }

            if (pageGroup === pageGroupType.ALL_CUSTOMERS) {
                const newFilter = await addSavedFilter(
                    {
                        pageGroup,
                        pageType: pageIdentifiersPageType.CUSTOMERS,
                    },
                    {
                        filter_query: pendingFilterQuery,
                        filters_list: pendingFilterList.map((filter) => {
                            return filter;
                        }),
                        filter_name: `${selectedCustomerFilterList} 2`,
                    },
                );

                const newUserPreferences = [...userPreferenceFilters];
                newUserPreferences.push({
                    id: newFilter?.id,
                    filterQuery: newFilter?.filter_query,
                    filterName: newFilter?.filter_name,
                    customerFiltersList: newFilter?.filters_list.map((filter) => {
                        return {
                            filterType: filter?.filterType,
                            applications: filter?.applications,
                            appFamilyKeys: filter?.appFamilyKeys,
                        };
                    }),
                });
                setUserPreferenceFilters(newUserPreferences);
            } else {
                const newFilter = await addSavedFilter(
                    {
                        pageGroup,
                        pageType: pageIdentifiersPageType.TOTALS,
                        familyId,
                    },
                    {
                        filter_query: pendingFilterQuery,
                        filters_list: pendingFilterList.map((filter) => {
                            if (filter.vaultBasics) {
                                if (filter.vaultBasics === VaultBasicsFilterOptions.Yes) {
                                    return { vaultBasics: true };
                                }
                                if (filter.vaultBasics === VaultBasicsFilterOptions.No) {
                                    return { vaultBasics: false };
                                }
                                return { vaultBasics: null };
                            }
                            return filter;
                        }),
                        filter_name: `${selectedCustomerFilterList} 2`,
                    },
                );

                const newUserPreferences = [...userPreferenceFilters];
                newUserPreferences.push({
                    id: newFilter?.id,
                    filterQuery: newFilter?.filter_query,
                    filterName: newFilter?.filter_name,
                    filterList: newFilter?.filters_list.map((filter) => {
                        return {
                            customerIds: filter?.customerIds,
                            vaultBasics: getVaultBasicsFilterOption(filter),
                            vaultSizes: filter?.vaultSizes,
                            podNames: filter?.podNames,
                            appKeys: filter?.appKeys,
                            statFilter: filter?.statFilter,
                            customerSizes: filter?.customerSizes,
                            industries: filter?.industries,
                            regions: filter?.regions,
                            segments: filter?.segments,
                        };
                    }),
                });
                setUserPreferenceFilters(newUserPreferences);
            }
        }
    };

    const handleHoverCopyClick = async (e, filterName) => {
        e.stopPropagation();
        const matchFilter = userPreferenceFilters.filter((f) => f.filterName === filterName);
        if (pageGroup === pageGroupType.ALL_CUSTOMERS) {
            if (matchFilter.length !== 0) {
                if (
                    matchFilter[0]?.filterQuery.length !== 0 &&
                    matchFilter[0]?.customerFiltersList.length !== 0
                ) {
                    if (
                        doesFilterNameExist(userPreferenceFilters, `${matchFilter[0].filterName} 2`)
                    ) {
                        showInvalidFilterNameNotification(`${matchFilter[0].filterName} 2`);
                        return;
                    }
                    const newFilter = await addSavedFilter(
                        {
                            pageGroup,
                            pageType: pageIdentifiersPageType.CUSTOMERS,
                            familyId,
                        },
                        {
                            filter_query: matchFilter[0].filterQuery,
                            filters_list: matchFilter[0].customerFiltersList.map((filter) => {
                                return filter;
                            }),
                            filter_name: `${matchFilter[0].filterName} 2`,
                        },
                    );

                    const newUserPreferences = [...userPreferenceFilters];
                    newUserPreferences.push({
                        id: newFilter?.id,
                        filterQuery: newFilter?.filter_query,
                        filterName: newFilter?.filter_name,
                        customerFiltersList: newFilter?.filters_list.map((filter) => {
                            return {
                                filterType: filter?.filterType,
                                applications: filter?.applications,
                                appFamilyKeys: filter?.appFamilyKeys,
                            };
                        }),
                    });
                    setPendingFilterList([]);
                    setPendingFilterQuery('');
                    setPendingFilterId('');
                    handleSetSelectedCustomerList('');
                    setUserPreferenceFilters(newUserPreferences);
                }
            }
        } else if (matchFilter.length !== 0) {
            if (
                matchFilter[0]?.filterQuery.length !== 0 &&
                matchFilter[0]?.filterList.length !== 0
            ) {
                if (doesFilterNameExist(userPreferenceFilters, `${matchFilter[0].filterName} 2`)) {
                    showInvalidFilterNameNotification(`${matchFilter[0].filterName} 2`);
                    return;
                }
                const newFilter = await addSavedFilter(
                    {
                        pageGroup,
                        pageType: pageIdentifiersPageType.TOTALS,
                        familyId,
                    },
                    {
                        filter_query: matchFilter[0].filterQuery,
                        filters_list: matchFilter[0].filterList.map((filter) => {
                            if (filter.vaultBasics) {
                                if (filter.vaultBasics === VaultBasicsFilterOptions.Yes) {
                                    return { vaultBasics: true };
                                }
                                if (filter.vaultBasics === VaultBasicsFilterOptions.No) {
                                    return { vaultBasics: false };
                                }
                                return { vaultBasics: null };
                            }
                            return filter;
                        }),
                        filter_name: `${matchFilter[0].filterName} 2`,
                    },
                );

                const newUserPreferences = [...userPreferenceFilters];
                newUserPreferences.push({
                    id: newFilter?.id,
                    filterQuery: newFilter?.filter_query,
                    filterName: newFilter?.filter_name,
                    filterList: newFilter?.filters_list.map((filter) => {
                        return {
                            customerIds: filter?.customerIds,
                            vaultBasics: getVaultBasicsFilterOption(filter),
                            vaultSizes: filter?.vaultSizes,
                            podNames: filter?.podNames,
                            appKeys: filter?.appKeys,
                            statFilter: filter?.statFilter,
                            customerSizes: filter?.customerSizes,
                            industries: filter?.industries,
                            regions: filter?.regions,
                            segments: filter?.segments,
                        };
                    }),
                });
                setPendingFilterList([]);
                setPendingFilterQuery('');
                setPendingFilterId('');
                handleSetSelectedCustomerList('');
                setUserPreferenceFilters(newUserPreferences);
            }
        }
    };

    const handleDeleteClick = () => {
        if (pageGroup === pageGroupType.ALL_CUSTOMERS) {
            deleteSavedFilter(
                {
                    pageGroup,
                    pageType: pageIdentifiersPageType.CUSTOMERS,
                },
                pendingFilterId,
            );
        } else {
            deleteSavedFilter(
                {
                    pageGroup,
                    pageType: pageIdentifiersPageType.TOTALS,
                    familyId,
                },
                pendingFilterId,
            );
        }

        setPendingFilterList([]);
        setPendingFilterQuery('');
        setPendingFilterId('');
        handleSetSelectedCustomerList('');
        setErrorMsg('');
        setUserPreferenceFilters(userPreferenceFilters.filter((f) => f.id !== pendingFilterId));
    };

    return userPreferenceFilters.map(({ filterName }) => {
        const isSelectedFilter = selectedCustomerFilterList === filterName;
        return (
            <tr
                key={filterName}
                onClick={() => handleSetSelectedCustomerList(filterName)}
                css={isSelectedFilter ? selectedRadioCSS : customerStatFilterRadioCSS}
            >
                <td>
                    <Radio
                        value={filterName}
                        checked={isSelectedFilter}
                        css={customerStatFilterRadioCSS}
                        onChange={() => handleSetSelectedCustomerList(filterName)}
                    />
                </td>
                <td>{filterName}</td>
                <td>
                    <CustomerStatFilterRadioCopyDeleteButtons
                        isSelectedFilter={isSelectedFilter}
                        filterName={filterName}
                        handleCopyClick={handleCopyClick}
                        handleDeleteClick={handleDeleteClick}
                        handleHoverCopyClick={handleHoverCopyClick}
                        handleHoverDeleteClick={handleHoverDeleteClick}
                        mobile={mobile}
                        canCopy={userPreferenceFilters.length !== 5}
                    />
                </td>
            </tr>
        );
    });
}

CustomCustomerStatFilter.propTypes = {
    familyId: PropTypes.number,
    mobile: PropTypes.bool,
    pageGroup: PropTypes.string,
    pendingFilterId: PropTypes.string,
    pendingFilterList: PropTypes.arrayOf(
        PropTypes.shape({
            appKeys: PropTypes.arrayOf(PropTypes.string),
            customerIds: PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            ),
            customerSizes: PropTypes.arrayOf(PropTypes.string),
            industries: PropTypes.arrayOf(PropTypes.string),
            podNames: PropTypes.arrayOf(PropTypes.string),
            regions: PropTypes.arrayOf(PropTypes.string),
            segments: PropTypes.arrayOf(PropTypes.string),
            vaultBasics: PropTypes.string,
            vaultSizes: PropTypes.arrayOf(PropTypes.string),
        }),
    ),
    pendingFilterQuery: PropTypes.string,
    selectedCustomerFilterList: PropTypes.string,
    setErrorMsg: PropTypes.func,
    setPendingFilterId: PropTypes.func,
    setPendingFilterList: PropTypes.func,
    setPendingFilterQuery: PropTypes.func,
    setSelectedCustomerFilterList: PropTypes.func,
    setUserPreferenceFilters: PropTypes.func,
    userPreferenceFilters: PropTypes.arrayOf(
        PropTypes.shape({
            customerIds: PropTypes.arrayOf(PropTypes.number),
            filterName: PropTypes.string,
            id: PropTypes.string,
        }),
    ),
};
